import type { BreadCrumbItemProps } from '../components/BreadCrumb';
import { useBreadcrumbStore } from '../store/breadcrumb.store';
import { isRef, type MaybeRef, type Ref, watchEffect } from 'vue';

export type UseBreadcrumbOptions = {
  hideBackButton?: boolean;
};

export const useBreadcrumb = (
  items:
    | MaybeRef<BreadCrumbItemProps[]>
    | Ref<BreadCrumbItemProps[], BreadCrumbItemProps[]>,
  options?: UseBreadcrumbOptions,
) => {
  const breadcrumbStore = useBreadcrumbStore();

  watchEffect(() => {
    const itemsValue = isRef(items) ? items.value : items;
    breadcrumbStore.setItems(itemsValue);
  });

  if (options?.hideBackButton !== undefined) {
    breadcrumbStore.setHideBackButton(options.hideBackButton);
  }
};
